import { Image } from "gf-ui";
import React from "react";
import { Row, Col } from "react-bootstrap";


const HeaderTicketPsStranieri = ({subtitle}) => {
  return (    
    <section className="header ticket-ps-stranieri w-100 p-4 m-0">
      <Row className=" p-0 m-0">
        <Col xs={6} className="text-start p-0 m-0">
          <Image src={`${process.env.REACT_APP_BASE_URL_PROD}stsInternet/images/layout/web/logoEnte.jpg`} className="header-logo" />
        </Col>
        <Col xs={6} className="text-end p-0 m-0">
          <Image src={`${process.env.REACT_APP_BASE_URL_PROD}/stsInternet/images/layout/web/logoRegione.jpg`} className="header-logo" />
        </Col>
      </Row>
    </section>
  )
}

export default HeaderTicketPsStranieri;